import React from "react";
import { s, globalCss } from "../lib/theme";

export function Shell({ children, header }) {
  return (
    <div style={s.page}>
      <style>{globalCss}</style>
      <div style={s.frame}>
        {header}
        {children}
      </div>
    </div>
  );
}

export function Header({ title, sub, right }) {
  return (
    <div style={s.header}>
      <div>
        <div style={s.brand}>Tennessee Implant &amp; Oral Surgery</div>
        <div style={s.title}>{title}</div>
        {sub && <div style={s.sub}>{sub}</div>}
      </div>
      <div>{right}</div>
    </div>
  );
}

export function StatusPill({ status }) {
  const map = {
    pending: { bg: "#fef3c7", fg: "#92400e", t: "Pending" },
    approved: { bg: "#dcfce7", fg: "#166534", t: "Approved" },
    denied: { bg: "#fee2e2", fg: "#991b1b", t: "Denied" },
  };
  const m = map[status] || map.pending;
  return <span data-testid={`status-pill-${status}`} style={{ ...s.pill, background: m.bg, color: m.fg }}>{m.t}</span>;
}

export function Tab({ id, tab, setTab, children, testId }) {
  const active = tab === id;
  return (
    <button
      data-testid={testId || `tab-${id}`}
      onClick={() => setTab(id)}
      style={{ ...s.tab, ...(active ? s.tabActive : {}) }}
    >
      {children}
    </button>
  );
}
